import React from 'react'

const CategoryToggleIcon = ({ className = '' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        className={className}
    >
        <path d="M7.64995 10.35V17.55H0.449951V10.35H7.64995ZM5.84995 12.15H2.24995V15.75H5.84995V12.15ZM8.54995 0L13.5 8.1H3.59995L8.54995 0ZM8.54995 3.474L6.82195 6.3H10.278L8.54995 3.474ZM13.5 9.9C15.75 9.9 17.55 11.7 17.55 13.95C17.55 16.2 15.75 18 13.5 18C11.25 18 9.44995 16.2 9.44995 13.95C9.44995 11.7 11.25 9.9 13.5 9.9ZM13.5 11.7C12.9032 11.7 12.3309 11.9371 11.909 12.359C11.487 12.781 11.25 13.3533 11.25 13.95C11.25 14.5467 11.487 15.119 11.909 15.541C12.3309 15.9629 12.9032 16.2 13.5 16.2C14.0967 16.2 14.669 15.9629 15.0909 15.541C15.5129 15.119 15.75 14.5467 15.75 13.95C15.75 13.3533 15.5129 12.781 15.0909 12.359C14.669 11.9371 14.0967 11.7 13.5 11.7Z" />
    </svg>
)
export default CategoryToggleIcon
